import { ProcurementTypeItemFragment } from 'generated/resources/graphql'

import { Form, SectionElement } from 'modules/forms'
import { Element } from 'modules/forms/lib/Element'

/**
 * Converts a Form Element to FormElementWithLocaleFragment format
 * This is the format expected by procurement GraphQL fragments
 */
function elementToFragment(element: Element, formId: string, parentSectionId?: string) {
  return {
    ...element,
    id: element.id || Math.random().toString(),
    description: element.description || '',
    formId,
    sectionId: parentSectionId || element.sectionId || '',
    type: element.getType(),
    createdAt: element.createdAt || new Date().toISOString(),
    updatedAt: element.updatedAt || new Date().toISOString(),
    options: element.options.map((option) => ({
      ...option,
      id: option.id || Math.random().toString(),
    })),
    params: element.params || {},
  }
}

export function generatePreview(
  RequestType: ProcurementTypeItemFragment,
  form: Form
): ProcurementTypeItemFragment {
  const formId = form.id || Math.random().toString()

  // Flatten all elements including those nested in sections
  const flattenElements = () =>
    form.elements.flatMap((element) => [
      elementToFragment(element, formId),
      ...(element instanceof SectionElement
        ? element.elements.map((nestedElement) =>
            elementToFragment(nestedElement, formId, element.id)
          )
        : []),
    ])

  const preview = {
    status: 'draft' as const,
    formType: 'custom' as const,
    resourceType: 'Procurement::Type' as const,
    id: formId,
    anonymous: false,
    description: form.description || '',
    resourceId: form.resourceId || '',
    title: form.title,
    elements: flattenElements(),
  }

  return {
    ...RequestType,
    formsConnection: {
      nodes: [preview],
    },
  }
}
